import { JetView } from "webix-jet";
import { getInfoList } from "../../helpers/infolist";
import { dateCommonFormat, dateFromISO } from "../../helpers/dateFormat";
import { statusBadge, userAvatar } from "helpers/templates";

export default class UsersView extends JetView {
	config() {
		this.WithRoles = this.app.config.roles;
		const padding = { left: 10 };
		const headers = {
			view: "toolbar",
			padding,
			cols: [
				{ view: "label", label: "User information", width: 125 },
				{
					view: "template",
					css: "webix_um_transparent",
					localId: "statusBadge",
					borderless: true,
				},

				{
					view: "icon",
					icon: "wxi-pencil",
					click: () => this.Edit(this.ID),
				},
			],
		};

		const userTemplate = {
			localId: "title",
			template: " ",
			autoheight: true,
		};

		const info = {
			localId: "info",
			template: " ",
			scroll: "auto",
			onClick: {
				webix_um_infolist_rules_name: e => {
					let id = webix.html.locate(e, "data-id");
					this.app.callEvent("details:item-click", ["rules", id]);
				},
				webix_um_infolist_roles_name: e => {
					let id = webix.html.locate(e, "data-id");
					this.app.callEvent("details:item-click", ["roles", id]);
				},
			},
		};

		const userDetails = {
			type: "clean",
			rows: [userTemplate, info],
		};

		return {
			maxWidth: 350,
			rows: [headers, userDetails],
		};
	}

	init() {
		this._ = this.app.getService("locale")._;
	}

	urlChange() {
		this.ID = this.getParam("id", true);
		const local = this.app.getService("local");
		let colls = [local.rules()];
		if (this.WithRoles) colls.push(local.roles());
		const users = local.users(true);
		users.waitData.then(() => {
			if (!this.getRoot()) return;

			const user = users.getItem(this.ID);
			this.SetTitle(user);
			Promise.all(colls).then(data => {
				this.SetDetails(user, data[0], data[1]);
			});
		});
	}

	SetTitle(user) {
		this.$$("statusBadge").setHTML(statusBadge(user.status, this._));
		this.$$("title").setHTML(this.TitleTemplate(user));
	}

	SetDetails(user, rules, roles) {
		this.$$("info").setHTML(this.GetDetailsHTML(user, roles, rules));
	}

	GetDetailsHTML(user, roles, rules) {
		let userDetails = "";
		userDetails += this.InfoTemplate(user.email, this._("Email"), "umi-email");
		userDetails += this.InfoTemplate(
			this.FormatDate(user.visited),
			this._("Last visited"),
			"umi-clock"
		);

		userDetails += this.GetListsHTML(user, roles, rules);

		return userDetails;
	}

	GetListsHTML(user, rolesData, rulesData) {
		const _ = this.app.getService("locale")._;
		const assignedStats = this.GetAssignments(user, rolesData, rulesData);
		let configs = [];
		if (this.WithRoles)
			configs.push({
				name: "roles",
				data: assignedStats.roles,
				key: "name",
				title: _("Roles"),
				icon: "umi-roles",
			});
		return getInfoList(
			configs.concat({
				name: "rules",
				data: assignedStats.rules,
				key: "long",
				title: _("Rules"),
				icon: "umi-rules",
			})
		);
	}

	GetAssignments(user, roles, rules) {
		const stats = {};

		stats.roles = [];
		stats.rules = [];

		if (this.WithRoles && user.roles) {
			roles.data.each(role => {
				if (user.roles.indexOf(role.id) >= 0) {
					stats.roles.push(role);
				}
			});
		}

		const rulesHash = {};
		// get rules assigned directly to a user (if any)
		if (user.rules) {
			rules.data.each(rule => {
				if (user.rules.indexOf(rule.id) >= 0 && !rulesHash[rule.id]) {
					rulesHash[rule.id] = true;
					stats.rules.push(rule);
				}
			});
		}
		// get rules according to assigned roles
		if (this.WithRoles)
			stats.roles.forEach(role => {
				if (role.rules) {
					rules.data.each(rule => {
						if (role.rules.indexOf(rule.id) >= 0 && !rulesHash[rule.id]) {
							rulesHash[rule.id] = true;
							stats.rules.push(rule);
						}
					});
				}
			});

		return stats;
	}

	TitleTemplate(user) {
		return `
			${userAvatar(user, "webix_um_avatarbox")}
			<div class="webix_um_title">${user.name || this._("Unknown user")}</div>`;
	}

	InfoTemplate(value, title, icon) {
		let result = `
			<div class='webix_um_infolist_header'><span class='webix_icon ${icon}'></span> ${title ||
			this._("Unknown")}:</div>
			<div class='webix_um_infolist_details'>${value || this._("Unknown")}</div>
		`;

		return result;
	}

	FormatDate(value) {
		if (value) {
			value = dateFromISO(value);
			value = dateCommonFormat(value);
		}
		return value || "";
	}

	Edit() {
		this.show("../users.editor");
	}
}
